module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('userLevel') == '1'
  ) ? _c('div', {
    staticStyle: {
      "margin-top": "-25px",
      "background": "#f8f8ff"
    }
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "page-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "lang": _vm.langCC,
      "format": "YYYY-MM-DD",
      "confirm": ""
    },
    on: {
      "change": _vm.onConfirmDateRangeCC
    },
    model: {
      value: (_vm.searchModal.dateRangeCC),
      callback: function($$v) {
        _vm.$set(_vm.searchModal, "dateRangeCC", $$v)
      },
      expression: "searchModal.dateRangeCC"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning btn-icon text-white mr-2",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "id": "daterange-btn",
      "data-toggle": "tooltip",
      "title": "",
      "data-placement": "bottom",
      "data-original-title": "Calendar"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadExcel('1')
      }
    }
  }, [_vm._m(1)])], 1)]), _vm._v(" "), _c('md-card-content', {
    staticStyle: {
      "background": "beige"
    }
  }, [_c('b-table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.filteredCC,
      "fields": _vm.fieldsCC,
      "per-page": _vm.perPageCC,
      "sort-by": _vm.sortByCC,
      "sort-desc": _vm.sortDescCC,
      "sort-direction": _vm.sortDirectionCC,
      "striped": ""
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortByCC = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDescCC = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "top-row",
      fn: function(ref) {
        var fields = ref.fields;

        return _vm._l((fields), function(fieldC) {
          return _c('td', {
            key: fieldC.key,
            staticStyle: {
              "background": "#43377b"
            }
          }, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.filtersCC[fieldC.key]),
              expression: "filtersCC[fieldC.key]"
            }],
            staticStyle: {
              "width": "130px",
              "height": "25px",
              "border-radius": "5px",
              "font-size": "12px",
              "text-align": "center"
            },
            attrs: {
              "placeholder": fieldC.label
            },
            domProps: {
              "value": (_vm.filtersCC[fieldC.key])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(_vm.filtersCC, fieldC.key, $event.target.value)
              }, function($event) {
                _vm.getAdvanceSearchDataCC('0', '1')
              }]
            }
          })])
        })
      }
    }, {
      key: "clientName",
      fn: function(row1) {
        return [_c('b', [_vm._v(_vm._s(row1.item.clientName))]), _vm._v(" "), _c('br'), _vm._v("\n          Assignment No :\n          " + _vm._s(row1.item.ccImportSeries) + "\n          "), _c('br'), _vm._v("\n          Assignment Date :\n          " + _vm._s(_vm._f("moment")(row1.item.loginTime)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('b-pagination', {
    attrs: {
      "per-page": _vm.perPageCC,
      "total-rows": _vm.totalRowsCC
    },
    on: {
      "change": function($event) {
        _vm.onPageChangeCC($event)
      }
    },
    model: {
      value: (_vm.currentPageCC),
      callback: function($$v) {
        _vm.currentPageCC = $$v
      },
      expression: "currentPageCC"
    }
  })], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title"
  }, [_c('span', {
    staticClass: "subpage-title"
  }, [_vm._v("Custom Clearance Export Reports")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06c7f97a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/dashboard/dashboardCcImpoReports.vue
// module id = 2369
// module chunks = 0